export const WHATSAPP_CONFIG_MODEL = {
    id : null,
    institutionId : null,
    phoneNumberId : '',
    wabaId : '',
    token : '',
    active : true
}